import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';
import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { FormPageLayout } from '#apps/client-web/app/components/form-page-layout';
import { auditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { fileStorageService } from '#apps/client-web/features/file-storage/services/file-storage';

import { CenteredLayout } from '#packages/web/foundations/layouts/centered-layout';

import { AuditFormBackgroundPageContainer } from './audit-form-background-page.container';
import { useAuditFormBackgroundPageViewModel } from './audit-form-background-page.view-model';

export const AuditFormBackgroundPage = () => {
  const logger = useLogger('pages/audit-form-background');

  const viewModel = useAuditFormBackgroundPageViewModel({
    auditFormService,
    fileStorageService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    logger,
  });

  return (
    <FormPageLayout
      title="Background"
      isFormChanged={viewModel.form.formState.isDirty}
      onSubmit={viewModel.onSubmit}
      isSubmitDisabled={viewModel.updateMutationState.state === 'pending'}>
      <CenteredLayout horizontal>
        <AuditFormBackgroundPageContainer viewModel={viewModel} />
      </CenteredLayout>
    </FormPageLayout>
  );
};
